<template>
  <div>
    <!-- Banner -->
    <v-banner color="secondary" outlined>
      <h2>گالری</h2>
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-left</v-icon>
        </template>
      </v-breadcrumbs>
    </v-banner>
    <!-- Posts -->
    <v-card>
      <v-tabs v-model="tab" color="deep-purple accent-4" left>
        <v-tab>تصاویر</v-tab>
        <v-tab>ویدیو</v-tab>

        <v-tab-item v-for="n in 2" :key="n">
          <v-container fluid>
            <v-lazy
              v-model="isActive"
              height="100%"
              :options="{
                threshold: 0.5,
              }"
              transition="fade-transition"
            >
              <v-row>
                <v-col
                  v-show="tab == 0"
                  v-for="(item, i) in image"
                  :key="i"
                  class="pa-1"
                  cols="6"
                  sm="6"
                  md="2"
                >
                  <v-dialog
                    transition="dialog-top-transition"
                    max-width="500"
                    max-height="430"
                  >
                    <!-- show slides && when clicked to card picture -->
                    <template v-slot:activator="{ on, attrs }">
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card
                            class="ma-1"
                            v-bind="attrs"
                            v-on="on"
                            v-for="(picture, j) in item.slice(0, 1)"
                            :key="'j' + j"
                            v-show="picture.type == 'IMAGE'"
                          >
                            <v-responsive>
                              <picture>
                                <source
                                  type="image/webp"
                                  :srcset="
                                    picture.type == 'IMAGE'
                                      ? picture.thumbnail
                                      : null
                                  "
                                />
                                <v-img
                                  :aspect-ratio="1 / 1"
                                  :src="
                                    picture.type == 'IMAGE'
                                      ? picture.medium
                                      : null
                                  "
                                >
                                  <v-row
                                    style="
                                      align-content: center;
                                      justify-content: center;
                                      align-items: center;
                                    "
                                  >
                                    <v-col
                                      class="pa-0"
                                      cols="1"
                                      v-for="(picture, p) in item"
                                      :key="p"
                                    >
                                      <v-badge
                                        bordered
                                        class="center"
                                        bottom
                                        color="success"
                                        dot
                                        offset-y="-65"
                                        offset-x="-4"
                                      >
                                      </v-badge>
                                    </v-col>
                                  </v-row>
                                </v-img>
                              </picture>
                            </v-responsive>
                            <v-fade-transition>
                              <v-overlay
                                v-if="hover"
                                absolute
                                color="#0000007d"
                              >
                              </v-overlay>
                            </v-fade-transition>
                          </v-card>
                        </template>
                      </v-hover>
                    </template>
                    <template>
                      <!-- <v-row>
                        <v-col cols="6" md="6" sm="12"> -->
                      <v-card
                        style="text-align: -webkit-center"
                        elevation="0"
                        v-show="tab == 0"
                        color="transparent"
                      >
                        <v-carousel
                          ref="myCarousel"
                          color="transparent"
                          class="rounded-xl"
                          :touchless="true"
                          show-arrows-on-hover
                          hide-delimiter-background
                          delimiter-icon="mdi-rhombus-outline"
                        >
                            <v-carousel-item
                              v-for="(picture, k) in item"
                              :key="'k' + k"
                            >
                              <v-img
                                class="rounded"
                                height="100%"
                                :src="
                                  picture.type == 'IMAGE'
                                    ? picture.medium
                                    : null
                                "
                                :aspect-ratio="16 / 9"
                              />
                            </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <!-- </v-col> -->
                      <!-- <v-col class="pa-0" cols="6" md="6" sm="12">
                          <v-card height="100%"></v-card>
                        </v-col>
                     </v-row> -->
                    </template>
                  </v-dialog>
                </v-col>
                <v-col
                  v-show="tab == 1"
                  v-for="(item, l) in video"
                  :key="'l' + l"
                  class="pa-1"
                  cols="6"
                  sm="6"
                  md="2"
                >
                  <v-dialog
                    transition="dialog-top-transition"
                    max-width="500"
                    max-height="430"
                  >
                    <!-- show slides && when clicked to card picture -->
                    <template v-slot:activator="{ on, attrs }">
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card
                            class="ma-1"
                            @click="videoDialog = true"
                            v-for="(film, m) in item.slice(0, 1)"
                            :key="'m' + m"
                            v-show="film.type == 'VIDEO'"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-responsive :aspect-ratio="1 / 1">
                              <picture>
                                <source
                                  type="image/webp"
                                  :srcset="
                                    film.type == 'VIDEO' ? film.thumbnail : null
                                  "
                                />
                                <v-img
                                  class="rounded"
                                  :src="
                                    film.type == 'VIDEO' ? film.thumbnail : null
                                  "
                                  aspect-ratio="1"
                                >
                                  <v-row
                                    style="
                                      align-content: center;
                                      justify-content: center;
                                      align-items: center;
                                    "
                                  >
                                    <v-col
                                      class="pa-0"
                                      cols="1"
                                      v-for="(film, f) in item"
                                      :key="f"
                                    >
                                      <v-badge
                                        bordered
                                        class="center"
                                        bottom
                                        color="success"
                                        dot
                                        offset-y="-65"
                                      >
                                      </v-badge>
                                    </v-col> </v-row
                                ></v-img>
                              </picture>
                            </v-responsive>
                            <v-fade-transition>
                              <v-overlay
                                v-if="hover"
                                absolute
                                color="#0000007d"
                              >
                              </v-overlay>
                            </v-fade-transition>
                          </v-card>
                        </template>
                      </v-hover>
                    </template>

                    <template>
                      <v-card
                        style="text-align: -webkit-center"
                        color="transparent"
                        elevation="0"
                        v-show="tab == 1"
                      >
                        <v-carousel
                          color="transparent"
                          hide-delimiter-background
                          :show-arrows="false"
                          hide-delimiters
                        >
                          <v-carousel-item
                            v-for="(film, o) in item"
                            :key="'o' + o"
                          >
                            <video
                              style="height: 100%; background-color: #3d3d3d"
                              ref="videoPlayer"
                              :src="film.type == 'VIDEO' ? film.medium : null"
                              type="video/mp4"
                              id="video-container"
                              width="100%"
                              controls
                              controlsList="nodownload"
                            />
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-lazy>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <!-- <v-row class="pa-6">
      <v-col class="pa-1" cols="6" sm="6" md="2"> </v-col>
    </v-row> -->
  </div>
</template>

<script>
// import VueGridLayout from "vue-grid-layout";
import videojs from "video.js";
export default {
  props: {
    customers: {},
  },
  data() {
    return {
      isActive: false,
      tab: "",
      image: [],
      video: [],
      items: [
        {
          text: "خانه",
          disabled: false,
          href: "/" + this.$route.params.name,
        },
        {
          text: "گالری",
          disabled: false,
          href: "gallery",
        },
      ],
      posts: [],
      media: [],
      objPost: [],
      pictureCheck: null,
      current_page: 1,
      last_page: 1,
      overlay: false,
      State: false,
      videoDialog: false,
      url: process.env.SITEURL,
      // customers: [],
      // tags: [],
      // title: "‌",
      // description: "",
      // keywords: [],
      // image: "",
      location: window.document.location.host.replace("www.", ""),
      videoOptions: {
        autoplay: true,
        controls: true,
      },
      player: null,
    };
  },
  components: { videojs },
  created() {
    this.localbooth();
  },
  // components: {
  //   GridLayout: VueGridLayout.GridLayout,
  //   GridItem: VueGridLayout.GridItem,
  // },
  metaInfo() {
    return {
      // title will be injected into parent titleTemplate
      title: "نامیا",
      titleTemplate: "%s | گالری",
    };
  },
  methods: {
    // async getPost() {
    //   let response = await this.axios
    //     .get("https://namya.ir/api/v1/businesses/posts?business=48")
    //     .then((response) => {
    //       this.post = response.data.data;
    //     });
    // },
    // async getPost() {
    //   var self = this;
    //   let responses = await this.axios
    //     .get("https://namya.ir/api/v1/domain/" + this.location, {
    //       headers: {
    //         "access-control-allow-headers":
    //           "'access-control-allow-methods','access-control-allow-origin'",
    //         "access-control-allow-methods":
    //           "PUT, GET, HEAD, POST, DELETE, OPTIONS",
    //         "access-control-allow-origin": "*",
    //       },
    //     })
    //     .then((responses) => {
    //       this.$emit("ID", responses.data.data);
    //       localStorage.setItem("ID", JSON.stringify(responses.data.data));
    //       this.booths();
    //     })
    //     .catch(() => {
    //       this.localbooth();
    //     });
    // },
    // async booths() {
    //   var self = this;
    //   let response = await self.axios.get(
    //     "https://namya.ir/api/v3/posts?business_id=" +
    //       localStorage.getItem("ID"),
    //     // "&page=" +
    //     // this.current_page,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${localStorage.token}`,
    //         "access-control-allow-headers":
    //           "'access-control-allow-methods','access-control-allow-origin'",
    //         "access-control-allow-methods":
    //           "PUT, GET, HEAD, POST, DELETE, OPTIONS",
    //         "access-control-allow-origin": "*",
    //       },
    //     }
    //   );
    //   // console.log(self.$route.params.name);
    //   this.posts.push(...response.data.data);
    // },
    async localbooth() {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v3/posts?business_id=48",
        // "&page=" +
        // this.current_page,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
            "access-control-allow-headers":
              "'access-control-allow-methods','access-control-allow-origin'",
            "access-control-allow-methods":
              "PUT, GET, HEAD, POST, DELETE, OPTIONS",
            "access-control-allow-origin": "*",
          },
        }
      );
      this.posts = response.data.data;
      for (let i = 0; i < this.posts.length; i++) {
        const element = this.posts[i];
        for (let j = 0; j < element.media_files.length; j++) {
          var checkImg = element.media_files[j];
        }
        if (checkImg.type == "IMAGE") {
          this.image.push(element.media_files);
        } else if (checkImg.type == "VIDEO") {
          this.video.push(element.media_files);
        }
      }

      // console.warn(this.video);
      // this.last_page = response.data.meta.last_page;
      // console.log(response.data.data.addresses);
    },
    handleScrolledBottom(isVisible) {
      if (!isVisible) {
        return;
      }
      if (this.current_page >= this.last_page) {
        return;
      }
      this.current_page++;
      this.getPost();
    },
  },
};
</script>

<style scoped>
*
  >>> div.v-window.v-item-group.theme--dark.v-window--show-arrows-on-hover.v-carousel.v-carousel--hide-delimiter-background
  div.v-image__image.v-image__image--cover {
  background-size: contain !important;
}
.v-banner__text {
  line-height: inherit !important;
}

* >>> .v-image__image--contain {
  background-size: cover;
}

.v-card {
  transition: opacity 0.2s ease-in-out;
}

.v-card:hover {
  opacity: 0.85;
}

.v-card:not(.on-hover) {
  opacity: 1;
}

.v-responsive {
  align-items: center;
}
</style>

<style lang="sass" scoped>
.v-card.on-hover.theme--dark
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>

<style>
.v-banner {
  height: 100px;
}

.v-application--is-rtl .v-banner__wrapper {
  padding: 15px 13px 0px 0px !important;
}

.v-banner__content {
  padding: 7px !important;
}

.v-application ul,
.v-application ol {
  margin-top: 7px;
}

.v-breadcrumbs {
  padding: 12px 15px;
}
.v-dialog {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0),
    0px 24px 38px 3px rgba(0, 0, 0, 0), 0px 9px 46px 8px rgba(0, 0, 0, 0);
}
.button-container.visible {
  top: 12px;
  display: none !important;
}
.v-tab {
  letter-spacing: 0;
}
.v-slide-group__wrapper {
  margin-right: 10px;
}
*
  >>> .v-carousel__controls__item.v-btn.v-item--active.v-btn--active.v-btn--icon.v-btn--round.theme--dark.v-size--small
  .mdi-rhombus-outline::before {
  content: "\F070B";
}

* >>> .theme--dark.v-btn--active:before,
.theme--dark.v-btn--active:hover:before {
  opacity: 0;
}
.v-carousel__controls {
}
</style>
